import { DISCOUNT_TYPE, RECEIPT_PAYMENT_MODE_ID } from "@elixir/types";
import { DiscountType, TPaymentModeNames } from "../types/receipt";

export const RECEIPT_DISCOUNT_TYPE: DiscountType[] = [
  {
    id: DISCOUNT_TYPE.AMOUNT,
    name: "₹",
  },
  {
    id: DISCOUNT_TYPE.PERCENTAGE,
    name: "%",
  },
];

export type TPaymodeObject = {
  paymode: RECEIPT_PAYMENT_MODE_ID;
  amount: number;
};

export type TPaymodeArrayObject = {
  id: RECEIPT_PAYMENT_MODE_ID;
  name: TPaymentModeNames;
};

export const PAY_MODES: Array<
  TPaymodeArrayObject & {
    isActive: boolean;
  }
> = [
  {
    id: RECEIPT_PAYMENT_MODE_ID.CASH,
    name: "Cash",
    isActive: true,
  },
  {
    id: RECEIPT_PAYMENT_MODE_ID.CREDIT_CARD,
    name: "Credit Card",
    isActive: true,
  },
  {
    id: RECEIPT_PAYMENT_MODE_ID.DEBIT_CARD,
    name: "Debit Card",
    isActive: true,
  },
  {
    id: RECEIPT_PAYMENT_MODE_ID.PAYTM,
    name: "Paytm",
    isActive: true,
  },
  {
    id: RECEIPT_PAYMENT_MODE_ID.GPAY,
    name: "GPay",
    isActive: true,
  },
  {
    id: RECEIPT_PAYMENT_MODE_ID.UPI,
    name: "UPI",
    isActive: true,
  },
  {
    id: RECEIPT_PAYMENT_MODE_ID.OTHER,
    name: "Other",
    isActive: true,
  },
  {
    id: RECEIPT_PAYMENT_MODE_ID.EKA_PREPAID,
    name: "Eka Prepaid",
    isActive: false,
  },
  {
    id: RECEIPT_PAYMENT_MODE_ID.EKA_POSTPAY,
    name: "Eka Postpay",
    isActive: false,
  },
];

export enum RECEIPT {
  CREATE_RECEIPT = "CREATE_RECEIPT",
  UPDATE_RECEIPT = "UPDATE_RECEIPT",
  RECEIPT_ACTIONS = "RECEIPT_ACTIONS",
}

export enum PAYMENT_STATUS {
  unbilled = "unbilled",
  success = "success",
  failed = "failed",
  created = "created",
  to_refund = "to_refund",
  refund_processed = "refund_processed",
  refunded = "refunded",
  cancelled = "cancelled",
}
